// Blog posts data - Add your blog posts here
export const blogPosts = [
  /*{
    id: 1,
    title: "شروع یادگیری React - تجربه‌های اولیه",
    titleEn: "Starting React Learning - First Experiences",
    slug: "starting-react-learning",
    date: "2025-01-15",
    category: "Frontend",
    categoryFa: "فرانت‌اند",
    excerpt:
      "در این پست تجربیات اولیه‌ام از یادگیری React را به اشتراک می‌گذارم...",
    excerptEn: "In this post, I share my initial experiences learning React...",
    content: "محتوا کامل پست...",
    contentEn: "Full post content...",
    image: "/img/blog/react.jpg",
    tags: ["React", "JavaScript", "Frontend"],
    tagsFa: ["ری‌اکت", "جاوااسکریپت", "فرانت‌اند"],
  },
  {
    id: 2,
    title: "یادگیری Deep Learning از صفر - تجربه‌های اولیه",
    titleEn: "Learning Deep Learning from Scratch - First Experiences",
    slug: "deep-learning-from-scratch",
    date: "2025-01-20",
    category: "AI / ML",
    categoryFa: "هوش مصنوعی",
    excerpt:
      "در این پست، تجربیاتم از شروع یادگیری Deep Learning را به اشتراک می‌گذارم. از چالش‌های اولیه تا منابع مفید و پروژه‌های عملی که انجام دادم.",
    excerptEn:
      "In this post, I share my experiences starting Deep Learning. From initial challenges to useful resources and practical projects I've done.",
    content: `
      <h2>چرا Deep Learning؟</h2>
      <p>یادگیری Deep Learning یکی از چالش‌های بزرگ من بود. همیشه دوست داشتم سیستم‌های هوشمند بسازم که بتوانند از داده‌ها یاد بگیرند و تصمیم‌گیری کنند.</p>
      
      <h2>شروع کار</h2>
      <p>با دوره‌های آنلاین شروع کردم و پروژه‌های کوچک می‌زدم تا مفاهیم را بهتر درک کنم.</p>
      
      <h3>اولین پروژه</h3>
      <p>اولین پروژه‌ام یک مدل ساده برای classification بود:</p>
      <pre><code>import tensorflow as tf

model = tf.keras.Sequential([
  tf.keras.layers.Dense(128, activation='relu'),
  tf.keras.layers.Dense(10, activation='softmax')
])

model.compile(
  optimizer='adam',
  loss='sparse_categorical_crossentropy',
  metrics=['accuracy']
])</code></pre>
      
      <h2>منابع مفید</h2>
      <ul>
        <li><a href="https://www.tensorflow.org" target="_blank">TensorFlow Documentation</a></li>
        <li><a href="https://www.coursera.org" target="_blank">Coursera Courses</a></li>
      </ul>
      
      <h2>نتیجه‌گیری</h2>
      <p>یادگیری Deep Learning نیاز به صبر و تمرین دارد، اما نتیجه‌اش ارزشش را دارد.</p>
    `,
    contentEn: `
      <h2>Why Deep Learning?</h2>
      <p>Learning Deep Learning was one of my biggest challenges. I always wanted to build intelligent systems that can learn from data and make decisions.</p>
      
      <h2>Getting Started</h2>
      <p>I started with online courses and small projects to better understand the concepts.</p>
      
      <h2>Conclusion</h2>
      <p>Learning Deep Learning requires patience and practice, but it's worth it.</p>
    `,
    image: null,
    tags: ["Deep Learning", "Python", "TensorFlow", "AI"],
    tagsFa: ["یادگیری عمیق", "پایتون", "TensorFlow", "هوش مصنوعی"],
  },*/
  {
    id: 3,
    title: "شروع ماجراجویی با n8n - از ایده تا پروژه‌های خفن",
    titleEn: "Diving into n8n - From Ideas to Next-Level Projects",
    slug: "n8n-adventures",
    date: "2025-11-17",
    category: "Automation / Workflow",
    categoryFa: "اتوماسیون و ورکفلو",
    excerpt:
      "در این پست قصد دارم مسیر یادگیری پیشرفته n8n را شروع کنم و پروژه‌های خفن بسازم. از قابلیت‌های جذاب تا تجربه‌های عملی که قراره ثبت کنم.",
    excerptEn:
      "In this post, I share my plan to level up my n8n skills and start building next-level automation projects.",
    image:
      "https://raw.githubusercontent.com/n8n-io/n8n/master/assets/n8n-logo.png", // مسیر عکس n8n اینجا
    content: `
  <h2>چرا n8n؟</h2>
  <p>n8n این روزها یکی از ترندترین ابزارهای اتوماسیون شده. هم اوپن‌سورسه، هم انعطافش بالاست و می‌تونه هر چیزی رو به هر چیزی وصل کنه. همین قدرتش باعث شد جدی‌تر سمتش بیام.</p>

  <h2>مسیر جدید من</h2>
  <p>من قبلاً با n8n کار کردم و چند تا ورکفلو ساده ساختم، ولی الان می‌خوام برم سراغ سطح پیشرفته. یعنی ساخت سیستم‌های واقعی، اتوماسیون‌های چند مرحله‌ای و پروژه‌هایی که یه چیز معمولی نباشن — یه چیز <strong>خفن</strong> باشن.</p>

  <h3>قراره چیا رو یاد بگیرم؟</h3>
  <ul>
    <li>اتصال چند سرویس و API به صورت همزمان</li>
    <li>ساخت ورکفلوهای هوشمند با شرط، فلو کنترل و داده‌های پیچیده</li>
    <li>کانکت کردن n8n با AI و ساخت اتوماسیون‌های ترکیبی</li>
    <li>دیپلوی n8n رو سرور شخصی برای پروژه‌های حرفه‌ای 🔥</li>
  </ul>

  <h2>چشم‌انداز</h2>
  <p>این مسیر فقط یادگیری نیست؛ قراره نتیجه‌اش بشه پروژه‌هایی که هم کاربردی‌ان، هم خفن، هم قابلیت ارائه تو رزومه و شبکه‌های اجتماعی رو دارن. این فقط شروعشه.</p>
`,
    contentEn: `
  <h2>Why n8n?</h2>
  <p>n8n is one of the hottest automation tools right now. It's open-source, super flexible, and perfect for connecting services, APIs, and custom workflows.</p>

  <h2>My Plan</h2>
  <p>I already know the basics of n8n, but now I want to push it further—building advanced workflows, smart automations, and real-world projects.</p>

  <h3>What I'll Learn</h3>
  <ul>
    <li>Multi-service and multi-API workflows</li>
    <li>Smart logic, conditions, and complex data flows</li>
    <li>AI integrations for hybrid automation</li>
    <li>Deploying n8n on personal servers for production-level projects</li>
  </ul>

  <h2>Vision</h2>
  <p>This journey isn't just about learning; it's about creating powerful, unique, and real projects that actually matter.</p>
`,
    tags: ["n8n", "Automation", "Workflow", "AI"],
    tagsFa: ["n8n", "اتوماسیون", "ورکفلو", "هوش مصنوعی"],
  },
  {
    id: 4,
    title: "هفته اول من با Django - استارت جدی بک‌اند",
    titleEn: "My First Week with Django - Getting Serious About Backend",
    slug: "learning-django-first-week",
    date: "2025-11-24",
    category: "Backend",
    categoryFa: "بک‌اند",
    excerpt:
      "تازه حدود یک هفته‌ست که یادگیری Django رو به صورت جدی شروع کردم و دارم کم‌کم پروژه‌های واقعی می‌زنم تا بک‌اند رو مثل فرانت‌اند عمیق یاد بگیرم.",
    excerptEn:
      "I started learning Django seriously about a week ago and I’m already building small real projects to understand backend development better.",
    content: `
  <h2>چرا سمت Django رفتم؟</h2>
  <p>بعد از کار روی فرانت‌اند و هوش مصنوعی، احساس کردم برای ساختن اپلیکیشن‌های کامل، به یک فریم‌ورک بک‌اند جدی نیاز دارم. بین گزینه‌های مختلف، Django به خاطر معماری تمیز، جامعه فعال و ارتباط خوبش با Python انتخاب اولم شد.</p>

  <h2>هفته اول؛ شروع جدی</h2>
  <p>حدود یک هفته‌ست که به صورت جدی جنگو رو استارت زدم. فقط به دید «دیدن چند ویدیو» جلو نرفتم؛ هر چیزی که یاد می‌گیرم سریع تبدیلش می‌کنم به یک پروژه کوچک: از ساخت یک وبلاگ ساده گرفته تا پیاده‌سازی پنل ادمین و مدل‌های دیتابیس. همین رویکرد پروژه‌محور باعث شده مفاهیم بهتر تو ذهنم بشینه.</p>

  <h3>الان دقیقاً دارم چیکار می‌کنم؟</h3>
  <ul>
    <li>کار با مدل‌ها، migrationها و ارتباط بین جداول دیتابیس</li>
    <li>ساخت viewها و آشنایی با معماری MTV در Django</li>
    <li>طراحی Templateهای ساده برای صفحات وب</li>
    <li>تمرین روی پروژه‌های کوچک تا وقتی آماده شدم، یک پروژه جدی‌تر بسازم</li>
  </ul>

  <h2>هدفم از یادگیری Django</h2>
  <p>هدف نهایی اینه که بتونم بک‌اند پروژه‌هایی که برای هوش مصنوعی، Agentها یا اتوماسیون‌ها می‌نویسم رو هم خودم توسعه بدم؛ یعنی از مرحله ایده تا محصول نهایی، مسیر کاملی داشته باشم. این پست فقط گزارش شروع کاره و تو پست‌های بعدی تجربه‌هام از پروژه‌های واقعی با Django رو هم می‌نویسم.</p>
`,
    contentEn: `
  <h2>Why Django?</h2>
  <p>After spending a lot of time on frontend and AI, I realized that to build complete apps I also need a solid backend framework. Among all options, Django became my main choice because of its clean architecture, strong community, and great integration with Python.</p>

  <h2>First Serious Week</h2>
  <p>It’s been about a week since I started learning Django seriously. Instead of just watching tutorials, I try to immediately turn each new concept into a small project: a simple blog, an admin panel, or a basic data model. This project-based approach helps me remember things much better.</p>

  <h3>What am I doing right now?</h3>
  <ul>
    <li>Working with models, migrations, and database relations</li>
    <li>Building views and understanding the MTV architecture</li>
    <li>Creating simple templates for web pages</li>
    <li>Experimenting with small projects to prepare for a bigger, real-world app</li>
  </ul>

  <h2>My Goal with Django</h2>
  <p>My long-term goal is to be able to develop the backend for the AI, agent, and automation projects I build — from idea to production. This post is just the beginning; in future posts I’ll share more about real projects I build with Django.</p>
`,
    image: "/img/django.jpg",
    tags: ["Django", "Python", "Backend", "Web Development"],
    tagsFa: ["Django", "پایتون", "بک‌اند", "توسعه وب"],
  }
  // Add more posts here following the same structure
  // برای اضافه کردن پست جدید، از template در blogPostTemplate.js استفاده کنید
];

// Helper function to get posts by language
export const getPostsByLanguage = (language) => {
  return blogPosts.map((post) => ({
    id: post.id,
    title: language === "fa" ? post.title : post.titleEn,
    slug: post.slug,
    date: post.date,
    category: language === "fa" ? post.categoryFa : post.category,
    excerpt: language === "fa" ? post.excerpt : post.excerptEn,
    content: language === "fa" ? post.content : post.contentEn,
    image: post.image,
    tags: language === "fa" ? post.tagsFa : post.tags,
  }));
};

// Helper function to get post by slug
export const getPostBySlug = (slug, language) => {
  const post = blogPosts.find((p) => p.slug === slug);
  if (!post) return null;

  return {
    id: post.id,
    title: language === "fa" ? post.title : post.titleEn,
    slug: post.slug,
    date: post.date,
    category: language === "fa" ? post.categoryFa : post.category,
    excerpt: language === "fa" ? post.excerpt : post.excerptEn,
    content: language === "fa" ? post.content : post.contentEn,
    image: post.image,
    tags: language === "fa" ? post.tagsFa : post.tags,
  };
  
};
